// extracted by mini-css-extract-plugin
module.exports = {"navbar":"SiteRetired_navbar__3ZwaI","siteRetired":"SiteRetired_siteRetired__2yrHf","button":"SiteRetired_button__1-B_s","content":"SiteRetired_content__l6G4C"};